import React from 'react';

const DefaultFeedback = ({ defaultFeedback }) => (

	<li className="answer-hint">
                     <span><h4 class="ans_feedback"><i class="fa fa-comments-o" aria-hidden="true"></i> feedback </h4>
                       { 
						typeof(defaultFeedback) !== "string"?
					 	<p >
					   	     {Object.keys(defaultFeedback).map(key => <li >{defaultFeedback[key]}</li>) }
					    </p>:
					    	<p > {defaultFeedback} </p>
					}	</span>
                  </li>
    
)

export default DefaultFeedback;